import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {UsagePoint} from '../../models/rt2012/Enedis/UsagePoint';
import {UsagePoint as GazaprUsagepoint} from '../../models/rt2012/Gazpar/UsagePoint';
import {Deserialize} from 'cerialize';

@Injectable({
  providedIn: 'root'
})
export class UsagePointSelectorService {

  baseApiUrl: string = environment.api.baseUrl;

  constructor(
    private http: HttpClient
  ) {
  }

  loadUsagePoints(usagePointIds: string, logementId: string): Promise<UsagePoint[]> {
    return this.http.get(`${this.baseApiUrl}rt2012/usage-point-ids/load`, {
      params: {
        usage_point_ids: usagePointIds,
        logement_id: logementId
      }
    }).toPromise().then(data => {
      return Deserialize(data, UsagePoint);
    });
  }

  loadUsagePointsGazpar(usagePointIds: string, logementId: string): Promise<GazaprUsagepoint[]> {
    return this.http.get(`${this.baseApiUrl}rt2012/usage-point-gazpar-ids/load`, {
      params: {
        usage_point_ids: usagePointIds,
        logement_id: logementId
      }
    }).toPromise().then(data => {
      return Deserialize(data, GazaprUsagepoint);
    });
  }
}
